export default __webpack_public_path__ + "static/media/runner-cabinet.9ca7c4a7.png";